import Vue from "vue";
import App from "./App";
import router from "./router";
import less from "less";
import axios from "axios";
import VueAxios from "vue-axios";
import "babel-polyfill";

Vue.use(VueAxios, axios);
Vue.prototype.$axios = axios;
//引入element UI
import "./assets/element/theme/index.css";
import ElementUI from "element-ui";
Vue.use(ElementUI);
//引入国际化I18n
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
//引入vuex
import store from "./store/index";
Vue.config.productionTip = false;
Vue.prototype.$baseUrl = process.env.BASE_URL;
//引入animate动画
import animated from "animate.css"; // npm install animate.css --save安装，在引入
Vue.use(animated);
//引入swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
// import 'swiper/swiper-bundle.css'
// import 'swiper/css/swiper.css'
// import 'swiper/dist/css/swiper.css'//（css需要单独引用）
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import EN from "@/common/lang/en";
import ZH from "@/common/lang/zh";
// import echarts from 'echarts'
// import china from 'echarts/map/json/china.json'
// echarts.registerMap('china', china)
// Vue.prototype.$echarts = echarts

//创建带有选项的 VueI18n 实例
const i18n = new VueI18n({
    locale: localStorage.getItem("lang") === "en" ? "en" : "zh", // 语言标识
    messages: {
        zh: ZH,
        en: EN
    }
});

/* eslint-disable no-new */
const vue = new Vue({
    el: "#app",
    router,
    i18n,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js